import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxBadgeComponent } from './rx-badge.component';

@NgModule({
  imports: [CommonModule, RxBadgeComponent],
  exports: [RxBadgeComponent],
})
export class RxBadgeModule {}
